export const PREFIX = 'FE';
export const GLOBAL_KEY = '__ENV';

type Environment = {
  [key: string]: string;
};

declare global {
  interface Window {
    [GLOBAL_KEY]: Environment;
  }
}

const prefixMatch = `${PREFIX}_`;
const isBrowser = globalThis.window !== undefined;
const TRUE_VALUES = new Set(['1', 'y', 'yes', 'true']);
const FALSE_VALUES = new Set(['0', 'n', 'no', 'false']);

export const read = (): Environment => {
  const keys = Object.keys(process.env).filter(key => key.startsWith(prefixMatch));
  keys.sort((a, b) => Number(a > b) - Number(a < b));

  return keys.reduce(
    (env, key) => {
      env[key] = process.env[key] as string;
      return env;
    },

    {} as Environment,
  );
};

// TODO: Create TS utils?
type AnyStringExcept<T extends string, NotAllowed> = T extends NotAllowed ? never : T;

function env(): Environment;
function env<T extends string>(key: AnyStringExcept<T, 'NODE_ENV'>): string;
function env<T extends string>(key?: AnyStringExcept<T, 'NODE_ENV'>): Environment | string {
  if (!key) return isBrowser ? window[GLOBAL_KEY] : read();
  const safeKey = `${PREFIX}_${key}`;

  if (!isBrowser) return process.env[safeKey] ?? process.env[key] ?? '';

  if (GLOBAL_KEY in window) {
    return window[GLOBAL_KEY][safeKey];
  }

  return process.env[safeKey] ?? '';
}

export function envBoolean<T extends string>(
  key: AnyStringExcept<T, 'NODE_ENV'>,
  defaultValue?: boolean,
): boolean | undefined {
  const val = env(key)?.toLowerCase();
  if (val) {
    if (TRUE_VALUES.has(val)) return true;
    if (FALSE_VALUES.has(val)) return false;
  }
  return defaultValue;
}

export const getStaticPrefix = (): string => env('STATIC_PREFIX') ?? '';

export default env;
